import React, { useEffect, useState } from 'react';
import { Drawer, Steps } from 'antd';
import { UserPartForm } from './UsersFormComponents/UserPartForm';
import { RolePartForm } from './UsersFormComponents/RolePartForm';

function UsersForm({
  selectItems,
  isActive,
  initialValues,
  fetchData,
  onClose,
}) {
  const isEditing = initialValues !== null;

  const [current, setCurrent] = useState(1);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    if (!isActive) {
      handleReset();
    }
  }, [isActive]);

  const handleNext = () => {
    setCurrent(current + 1);
  };

  const handlePrev = () => {
    setCurrent(current - 1);
  };

  const handleReset = () => {
    setCurrent(0);
    setUserId(null);
    onClose();
  };

  const steps = [
    {
      title: `${isEditing ? 'Редактирование' : 'Создание'} пользователя`,
      content: (
        <UserPartForm
          initialValues={initialValues}
          onMoveNext={handleNext}
          onFetch={fetchData}
          onSubmit={setUserId}
        />
      ),
    },
    {
      title: `${isEditing ? 'Редактировать' : 'Предоставить'} роль`,
      content: (
        <RolePartForm
          userId={userId}
          initialValues={initialValues}
          selectItems={selectItems}
          onFetch={fetchData}
          onResetStep={handleReset}
          onMovePrev={handlePrev}
        />
      ),
    },
  ];

  return (
    <Drawer
      title={`${isEditing ? 'Редактирование' : 'Создание'} пользователя`}
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Steps current={current} style={{ marginBottom: '30px' }}>
        {steps.map((item) => (
          <Steps.Step key={item.title} title={item.title} />
        ))}
      </Steps>

      {steps[current].content}
    </Drawer>
  );
}

export { UsersForm };
